const statusSiteUserPublisher = {
  PENDING: "در حال انتظار",
  CONFIRM: "تایید شده",
  REJECT: "رد شده",
};

const statusSiteUserPublisherNumber = {
  PENDING: 1,
  CONFIRM: 2,
  REJECT: 3,
};

const statusSiteUserPublisherString = () => {
  let data = {};
  data[statusSiteUserPublisher.PENDING] = "در حال انتظار";
  data[statusSiteUserPublisher.CONFIRM] = "تایید شده";
  data[statusSiteUserPublisher.REJECT] = "رد شده";

  return data;
};

const activeSiteUserPublisher = {
  ACTIVE: true,
  DEACTIVATE: false,
};

const getActiveSiteUserPublisherString = () => {
  let data = {};
  data[activeSiteUserPublisher.ACTIVE] = "فعال";
  data[activeSiteUserPublisher.DEACTIVATE] = "غیرفعال";

  return data;
};

export default {
  statusSiteUserPublisher,
  getActiveSiteUserPublisherString,
  activeSiteUserPublisher,
};
